import { useState, useEffect, useCallback } from "react";
import { getExpertPurchases } from "../Services/ExpertPurchaseService";

const useExpertPurchases = (token) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [meta, setMeta] = useState({ totalCount: 0, totalPages: 1, pageNumber: 1 });

  const loadData = useCallback(async (page = 1) => {
    if (!token) return;
    try {
      setLoading(true);
      const res = await getExpertPurchases(token, { pageNumber: page });
      setData(res.items || []);
      setMeta({
        totalCount: res.totalCount,
        totalPages: res.totalPages,
        pageNumber: res.pageNumber,
      });
    } catch (err) {
      setError("Could not load expert services.");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return { data, loading, error, meta, refresh: loadData };
};

export default useExpertPurchases;